import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { SharedService } from 'src/app/core/shared/shared.service';
import { switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-impersonate-login',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './impersonate-login.component.html',
})
export class ImpersonateLoginComponent {

    isLoading = true;
    errorMessage = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: LoginService,
        private sharedService: SharedService,
    ) {
        this.handleImpersonation();
    }

    private handleImpersonation(): void {
        const token = this.route.snapshot.queryParamMap.get('token');

        if (!token) {
            this.handleError('No impersonation token provided');
            return;
        }

        this.authService.impersonateLogin(token).pipe(
            switchMap((res: any) => {
                if (!res?.accessToken) {
                    throw new Error('Invalid token response');
                }

                // Store token
                localStorage.setItem('accessToken', res.accessToken);

                // Load user
                return this.sharedService.loadCurrentUser();
            }),
            switchMap(() => this.sharedService.currentUser$)
        ).subscribe({
            next: () => {
                this.isLoading = false;
                this.router.navigate(['/dashboard']);
            },
            error: () => {
                this.handleError('Impersonation failed or expired');
            }
        });
    }

    private handleError(message: string): void {
        this.errorMessage = message;
        this.isLoading = false;

        setTimeout(() => {
            this.router.navigate(['/login']);
        }, 1500);
    }
}
